import type { FC } from "react"

import { useRecoilValue } from "recoil"

import {
  findProjectedPanelState,
  panelSelectionState,
} from "../../../state/elements/panels"
import { CoordinateTooltip } from "../../Overlays/CoordinateTooltip"

const PanelLabel: FC<{ id: string }> = ({ id }) => {
  const panel = useRecoilValue(findProjectedPanelState(id))

  return (
    <CoordinateTooltip
      size={{ w: 50, h: 30 }}
      where={panel}
      says={id.slice(0, 4)}
    />
  )
}

const PanelLabels: FC = () => {
  const panelIdSelection = useRecoilValue(panelSelectionState)
  const panelSelection = [...panelIdSelection]

  return (
    <>
      {panelSelection.map((id) => (
        <PanelLabel key={`panel-label` + id} id={id} />
      ))}
    </>
  )
}

export default PanelLabels
